import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import HomePage from './pages/HomePage';
import reportWebVitals from './reportWebVitals';
import {HashRouter, Navigate, Route, Routes} from 'react-router-dom';
import OurValuesPage from './pages/OurValuesPage';
import ContactUsPage from './pages/ContactUsPage';
import {ThemeProvider} from '@material-tailwind/react';
import LanguageDetector from 'i18next-browser-languagedetector';
import {en, ru} from './i18n';
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Solutions from './pages/Solutions';
import Prices from './pages/Prices';
import Blog from './pages/Blog';
import {BlogProvider} from './BlogContext';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    detection: {
      supportedLngs: ['en', 'ru'],
      convertDetectedLanguage: (lang) => lang.toLowerCase().substring(0, Math.max(2, lang.toLowerCase().indexOf('_'), lang.toLowerCase().indexOf('-')))
    },
    interpolation: {
      escapeValue: false
    }
  });
i18n.addResourceBundle('en', 'translation', en);
i18n.addResourceBundle('ru', 'translation', ru);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BlogProvider>
      <ThemeProvider>
        <HashRouter basename={'/'}>
          <Routes>
            <Route path={'/'} element={<HomePage/>}/>
            <Route path={'/our-values'} element={<OurValuesPage/>}/>
            <Route path={'/contact-us'} element={<ContactUsPage/>}/>
            <Route path={'/solutions'} element={<Solutions/>}/>
            <Route path={'/prices'} element={<Prices/>}/>
            <Route path={'/blog'} element={<Blog/>}/>
            <Route path={'/blog/:id'} element={<Blog/>}/>
            <Route path={'*'} element={<Navigate to={'/'} replace/>}/>
          </Routes>
        </HashRouter>
      </ThemeProvider>
    </BlogProvider>
  </React.StrictMode>
);

reportWebVitals();
